import React from 'react'

export const RatingStar: React.FC<{ raceConfidence: number }> = ({ raceConfidence }) => {
  const clipPathId = React.useId()
  return (
    <svg viewBox='0,0,500,100'>
      <defs>
        <clipPath id={clipPathId}>
          <path d='M77.9,92L50,77.7L22.2,92.1l5.3-30.4L5,40.1l31.1-4.5L50,7.9l13.9,27.7L95,40L72.5,61.6L77.9,92z' />
          <path d='M277.9,92L250,77.7l-27.8,14.4l5.3-30.4L205,40.1l31.1-4.5L250,7.9l13.9,27.7L295,40l-22.5,21.6L277.9,92z' />
          <path d='M477.9,92L450,77.7l-27.8,14.4l5.3-30.4L405,40.1l31.1-4.5L450,7.9l13.9,27.7L495,40l-22.5,21.6L477.9,92z' />
          <path d='M377.9,92L350,77.7l-27.8,14.4l5.3-30.4L305,40.1l31.1-4.5L350,7.9l13.9,27.7L395,40l-22.5,21.6L377.9,92z' />
          <path d='M177.9,92L150,77.7l-27.8,14.4l5.3-30.4L105,40.1l31.1-4.5L150,7.9l13.9,27.7L195,40l-22.5,21.6L177.9,92z' />
        </clipPath>
      </defs>
      <rect fill='#e8e8e8' x='0' y='0' width='500' height='100' clipPath={`url(#${clipPathId})`} />
      <rect
        fill='#723D91'
        x='0'
        y='0'
        width={5 * raceConfidence}
        height='100'
        clipPath={`url(#${clipPathId})`}
      />
    </svg>
  )
}
